import { describeOrderActionError } from '../actionErrors';

export interface BulkFailure {
  // `label` for grain-grouped actions (a customer/order name); `loadNumber` for
  // per-load actions. Whichever is set names the first failure in the summary.
  item: { loadNumber?: string | null; label?: string | null };
  error: string;
}

export interface BulkSummary {
  tone: 'success' | 'warn';
  message: string;
  clearSelection: boolean;
}

// Admin-facing summary of a bulk result, generalized over the entity noun
// ("load", "order", "customer") and a past-tense outcome ("assigned", "invoiced").
// A partial failure names the first one and keeps the selection so it can be retried.
export function summarizeBulk(
  succeeded: unknown[],
  failed: BulkFailure[],
  attempted: number,
  outcome: string,
  noun = 'load'
): BulkSummary {
  const s = (n: number) => (n === 1 ? '' : 's');

  if (failed.length === 0) {
    return {
      tone: 'success',
      message: `${succeeded.length} ${noun}${s(succeeded.length)} ${outcome}.`,
      clearSelection: true,
    };
  }

  const first = failed[0];
  const firstLabel = first.item.label ?? first.item.loadNumber ?? `a ${noun}`;
  return {
    tone: 'warn',
    message:
      `${succeeded.length} of ${attempted} ${outcome}. ${failed.length} failed. ` +
      `${firstLabel}: ${describeOrderActionError(first.error, 'failed')}`,
    clearSelection: false,
  };
}
